"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrderListApi = getOrderListApi;
exports.repairOrderApi = repairOrderApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 订单列表
 * @param params
 */
function getOrderListApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/fortune/orderDetail/list',
    method: 'GET',
    params: params
  });
}

/**
 * 补单
 * @param data
 */
function repairOrderApi(data) {
  return (0, _request.default)({
    url: 'admin/platform/fortune/orderDetail/repair',
    method: 'POST',
    data: data
  });
}